import * as React from 'react';
import Mobile from './Mobile/Mobile';
import Seo from './Seo/Seo';
import styled from 'styled-components';
import Support from './Support/Support';
import Trust from './Trust/Trust';

const LAFooterContainer = () => {
    return (
        <StyledFooter>
            <Mobile />
            <Trust />
            <Seo />
            <Support />
        </StyledFooter>
    );
};

export default React.memo(LAFooterContainer);

const StyledFooter = styled.div`
    @media print {
        display: none;
    }
`;
